module.exports = __webpack_public_path__ + "static/media/profile-placeholder-f.5b993715.png";